// Third Party
import React, { ReactElement } from 'react';
import classNames from 'classnames';

// Components
import Input, { Props as InputProps } from './Input';

export enum UnitSymbolSection {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

type Props = Partial<InputProps> & {
  id?: string;
  symbolSection?: UnitSymbolSection;
  unitSymbol?: string | ReactElement;
  label?: string;
  hasHiddenLabel?: boolean;
};

const UnitInput = (props: Props) => {
  const { className, onClick, symbolSection, unitSymbol, ...rest } = props;

  const unitElement = unitSymbol ? <div className="unit-symbol">{unitSymbol}</div> : undefined;

  switch (symbolSection) {
    case UnitSymbolSection.LEFT:
      return <Input className={classNames('unit-input', className)} leftSection={unitElement} onClick={onClick} {...rest} />;
    case UnitSymbolSection.RIGHT:
      return <Input className={classNames('unit-input', className)} onClick={onClick} rightSection={unitElement} {...rest} />;
    default:
      return <Input className={classNames('unit-input', className)} onClick={onClick} rightSection={unitElement} {...rest} />;
  }
};

export default UnitInput;
